import withBonnetDataIsland from '@atc/bonnet-ctx-data-island';
import getDataIsland from '../services/dataisland';

export default function withDataIsland() {
    return (ctx) => {
        const data = getDataIsland(ctx);
        return withBonnetDataIsland({ data })(ctx);
    };
}
